import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import TextBoxViewModel from '@/ViewModels/Controls/TextBoxViewModel';

export default class TextBox extends Control {

    private jQueryControl: JQuery;
    public label: any;
    private Label: any = ComponentManager.getControl('Label');

    public constructor(private viewModel: TextBoxViewModel, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    private onWidgetCreatedCallback(widget) {
        let jQueryControl = this.jQueryControl
        if (this.jQueryControl.hasClass('wrapper')) {
            jQueryControl = $(this.jQueryControl.children()[0]);
        }
        
        const innerWrapper = this.jQueryControl.find('.inner-wrapper');
        if (innerWrapper.length > 0) {
            this.applyBindings(innerWrapper, {
                invalid: this.viewModel.invalidationText,
            });
        } else {
            this.applyBindings(jQueryControl, {
                invalid: this.viewModel.invalidationText,
            });
        }

        this.applyBindings(jQueryControl, {
            controlName: 'textbox',

            loader: this.viewModel.isBusy,
            controlIdent: this.identifier,
            visible: this.viewModel.isVisible,
            tooltip: this.viewModel.tooltip,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];
                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel["onFocusOut"]) {
            let $input = this.jQueryControl.find('input');
            $input.focusout(() => {
                this.viewModel["onFocusOut"]();
            });
        }

        if (this.viewModel.maxLength >= 0) {
            this.jQueryControl.find('input').attr('maxlength', this.viewModel.maxLength);
        }

        if (this.viewModel.ariaLabel) {
            this.jQueryControl.find('input').attr('aria-label', this.viewModel.ariaLabel);
        }

        this.applyBindings(this.jQueryControl.find('input'), {
            focus: this.viewModel.isFocusable,

            classes: ['k-textbox'],

            locator: this.viewModel.locator,

            attr: {
                name: this.viewModel.name,

                lang: this.viewModel.language,

                readonly: this.defineComputed(() => {
                    return !this.viewModel.isEnabled();
                }),

                placeholder: this.viewModel.placeholder
            },

            textInput: this.viewModel.value
        });

        if (this.viewModel.label != null) {
            this.label = new this.Label(this.viewModel.label);
            let tuple = this.label.getTuple();
            this.jQueryControl.find('.c-textbox').append(tuple.control);
        }

        if (this.viewModel.onChange != null) {
            this.defineComputed(() => {
                this.viewModel.onChange(this.viewModel.value());
            });
        }

        if (this.viewModel.onKeyDown != null) {
            this.addEventHandler('keydown', this.jQueryControl, (event) => {
                this.viewModel.onKeyDown(event.keyCode);
            }, 'input');
        }

        this.addEventHandler('keyup', this.jQueryControl, (event) => {
            if (!this.viewModel.isEnabled())
                return;

            this.viewModel.value($(event.target).val() as string);

            if (this.viewModel.onKeyUp != null) {
                this.viewModel.onKeyUp(event.keyCode);
            }
        }, 'input');

        if (this.viewModel.onSubmit != null) {
            this.addEventHandler('keypress', this.jQueryControl, (event) => {
                if (event.key === 'Enter') {
                    this.viewModel.onSubmit(this.viewModel.value());
                }
            });
        }
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div class="wrapper"><div><div class="inner-wrapper"><input type="text"></div></div></div>');

        this.widget(null);

        return this.jQueryControl;
    }

    public addLabelReference(label: JQuery): JQuery {
        let id = this.identifier + '-input';
        this.jQueryControl.find('input').attr('id', id);
        label.attr('for', id);
        return label;
    }
}

ComponentManager.setControl('TextBox', TextBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');